import importer from 'common/importer'

const initializeApp = importer('Sagas/Startup/initializeApp/initializeApp')
const initializeAppSuccess = importer('Sagas/Startup/initializeApp/initializeAppSuccess')
const initializeAppFailure = importer('Sagas/Startup/initializeApp/initializeAppFailure')

export default {
  initializeApp,
  initializeAppSuccess,
  initializeAppFailure
}
